import React from 'react';
import '../styles/Profile.css';
import '../styles/Button.css';
import PDF from '../helpers/PDF';

function Profile(props) {
  const fname = props.data.fname.charAt(0).toUpperCase() + props.data.fname.slice(1);
  const lname = props.data.lname.charAt(0).toUpperCase() + props.data.lname.slice(1);

  return (
    <div className="container mb-5">
      <div className="column is-12 is-flex is-justify-content-space-between">
        <div className='is-flex'>
          <figure className="image is-32x32">
            <img className='is-rounded pic' src={props.data?.image} alt='' />
          </figure>
          <p className='ml-2 is-size-5'>{fname} {lname}</p>
        </div>
        <div>
          <button className="button btn" onClick={() => { props.handlePopup(props.item) }} >
            <span className="icon is-small">
              <i className="fab fa-readme"></i>
            </span>
            <span>Read</span>
          </button>
          <button className="button mx-2 btn" onClick={() => { PDF(props.item) }}>
            <span className="icon is-small">
              <i className="fas fa-print"></i>
            </span>
            <span>Print</span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default Profile;